import React from 'react'

import clsx from 'clsx'

import classes from './CircularProgress.module.scss'

/** @type {import("./types").default} */
const CircularProgress = ({ size, color, className }) => {
  return (
    <div className={clsx('CircularProgress', className, classes[color])} style={{ width: size, height: size }}>
      <svg className={classes.svg} viewBox="22 22 44 44">
        <circle className={classes.circle} cx="44" cy="44" r="20.2" fill="none" strokeWidth="3.6"></circle>
      </svg>
    </div>
  )
}
export default CircularProgress
